<template>
  <div class="vue-loader-container">
    <div class="loader-icon-container">
      <img :src="publicUrl + '/fasal-loader.gif'" width="60px" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "LoaderComponent",
    data() {
      return {
        publicUrl: process.env.PUBLIC_URL
      }
    }
  }
</script>
<style lang="scss" scoped>
  .vue-loader-container {
    position: absolute;
    left: 0px;
    background: white;
    z-index: 99;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
</style>
